import React, { useRef } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/Header";
import Navbar from "./components/Navbar";
import ImageSlider from "./components/ImageSlider";
import AboutUs from "./components/Aboutus";
import AboutUsKnowMore from "./components/Aboutus_knowmore";
import ProductBasketSlider from "./components/Product";
import WhatWeOffer from "./components/whatweoffer";
import Product from "./components/Product_extended";
import Services from "./components/Services";
import ServiceDetail from "./components/ServiceDetail";
import ReturnCalculator from "./components/ReturnCalculator"; // Import Return Calculator
import ContactUs from "./components/Contact"; // Contact section on the homepage
import ContactUsExtend from "./components/Contactus_extend"; // Separate Contact Page
import Footer from "./components/Footer"; 
import "bootstrap/dist/css/bootstrap.min.css";
import LinksSection from "./components/LinksSection";

function App() {
  const contactRef = useRef(null);
  const aboutUsRef = useRef(null);
  const productRef = useRef(null);

  const scrollToSection = (sectionRef) => {
    if (sectionRef?.current) {
      sectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <Navbar
          scrollToAboutUs={() => scrollToSection(aboutUsRef)}
          scrollToContact={() => scrollToSection(contactRef)}
          scrollToProduct={() => scrollToSection(productRef)}
        />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <ImageSlider />
                <div ref={aboutUsRef}>
                  <AboutUs scrollToContact={() => scrollToSection(contactRef)} />
                </div>
                <div ref={productRef}>
                  <ProductBasketSlider />
                </div>
                <WhatWeOffer />
                <div ref={contactRef}>
                  <ContactUs />
                </div>
              </>
            }
          />

          {/* About Us Separate Page */}
          <Route path="/aboutus-knowmore" element={<AboutUsKnowMore />} />

          {/* Services & Service Details */}
          <Route path="/services" element={<Services />} />
          <Route path="/services/:serviceId" element={<ServiceDetail />} />

          {/* Product Page */}
          <Route path="/products" element={<Product />} />

          {/* Return Calculator (Above Contact Page) */}
          <Route path="/return-calculator" element={<ReturnCalculator />} />


          {/* Contact Page (Kept Below Calculators) */}
          <Route path="/contact" element={<ContactUsExtend />} />
        </Routes>
        <LinksSection />
        <Footer /> {/* Footer stays at the bottom */}
      </div>
    </Router>
  );
}

export default App;
